import { ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}


export function generateId(): string {
  return Math.random().toString(36).substring(2, 9);
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(2)} MB`;
}

export function formatTime(date: Date): string {
  return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

function hslToHex(h: any, s: any, l: any) {
  s /= 100;
  l /= 100;

  const a = s * Math.min(l, 1 - l);
  const f = (n: any) => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color).toString(16).padStart(2, '0');
  };

  return `#${f(0)}${f(8)}${f(4)}`;
}

export function generateColorPalette(count = 100) {
  const colors = [];
  const GOLDEN_ANGLE = 137.508;

  for (let i = 0; i < count; i++) {
    const hue = (i * GOLDEN_ANGLE) % 360;
    const row = Math.floor(i / 10);
    const saturation = 55 + (row % 2) * 20 + (i % 3) * 8;
    const lightness = 35 + (row % 4) * 12;

    colors.push(hslToHex(hue,
      Math.min(saturation, 95),
      Math.min(Math.max(lightness, 30), 70)
    ));
  }

  return colors;
}

export const COLOR_PALETTE = generateColorPalette(100);

export function assignConsumerColors(consumerIds: any) {
  const colors: any = {};
  consumerIds.forEach((id: any, index: number) => {
    colors[id as keyof object] = COLOR_PALETTE[index % COLOR_PALETTE.length];
  });
  return colors;
}